/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LuminisServiceUtils from "./utils/luminis-service-utils.es6.js";
import MyChartUser from "./mychart-user.es6.js";
import OverlayService from "./overlay-service.es6.js";
var Account = function () {
  function Account() {
    _classCallCheck(this, Account);
    this.accountButton = document.querySelector('.account-button-wrapper');
    this.accountWrapperId = document.querySelector('#account-nav');
    if (this.accountWrapperId) {
      this.mobileAccountWrapper = this.accountWrapperId.querySelector('.mobile-account-nav-wrapper');
      this.desktopAccountWrapper = this.accountWrapperId.querySelector('.desktop-account-nav-wrapper');
      this.body = document.querySelector('body');
      this.closeButtons = this.mobileAccountWrapper.querySelectorAll('.close-button');
      this.loggedOutText = this.accountButton.querySelector('.account-text-logged-out');
      this.loggedInText = this.accountButton.querySelector('.account-text-logged-in');
      this.logOutButtons = this.accountWrapperId.querySelectorAll('.log-out-wrapper');
      this.logInButtons = this.accountWrapperId.querySelectorAll('.log-in-button');
      this.header = document.querySelector('.site-header__inner__container');
      this.amountAccountNavShouldOverlapHeader = 15;
      this.desktopNavWrapperTop = 0;
      this.siteAlertWrapper = document.querySelector('.site-alert');
      this.primaryMenu = document.querySelector('.block-luminis-main-menu-menu');
      this.greetingTextList = document.querySelectorAll('.greeting-wrapper .greeting-text');
      this.loggedOutFooterBlocks = document.querySelectorAll('.menu--footer-buttons');
      this.loggedInFooterBlocks = document.querySelectorAll('.menu--my-dashboard');
      this.messagesMenu = document.querySelectorAll('.messages-wrapper .messages-text');
    }
    this.messageCount = sessionStorage.getItem('mychartMessageCount');
  }
  return _createClass(Account, [{
    key: "getVisibleHeightOfSiteAlerts",
    value: function getVisibleHeightOfSiteAlerts() {
      if (this.siteAlertWrapper) {
        var visibleHeightOfAlerts = window.scrollY - this.siteAlertWrapper.scrollHeight;
        if (-visibleHeightOfAlerts > 0) return -visibleHeightOfAlerts;
        return 0;
      }
      return 0;
    }
  }, {
    key: "getVisibleHeightOfNavbar",
    value: function getVisibleHeightOfNavbar() {
      if (this.header.getBoundingClientRect().top < 0) {
        return this.header.offsetHeight + this.header.getBoundingClientRect().top;
      }
      return this.header.offsetHeight;
    }
  }, {
    key: "setDesktopNavWrapperTop",
    value: function setDesktopNavWrapperTop() {
      this.desktopNavWrapperTop = this.header.offsetHeight - this.amountAccountNavShouldOverlapHeader;
    }
  }, {
    key: "setDesktopAccountNavCoords",
    value: function setDesktopAccountNavCoords() {
      var headerPadding = 20;
      this.desktopAccountWrapper.style.right = "".concat(this.header.offsetLeft + headerPadding, "px");
      this.desktopAccountWrapper.style.top = "".concat(this.desktopNavWrapperTop, "px");
    }
  }, {
    key: "setDesktopNavHeight",
    value: function setDesktopNavHeight() {
      var totalNeededHeight = this.desktopAccountWrapper.scrollHeight + this.getVisibleHeightOfNavbar() - this.amountAccountNavShouldOverlapHeader;
      var usableWindowHeight = window.innerHeight - this.getVisibleHeightOfSiteAlerts();
      var maxHeaderHeight = 169;
      if (totalNeededHeight > usableWindowHeight) {
        if (this.header.getBoundingClientRect().top < maxHeaderHeight) {
          this.desktopAccountWrapper.style.height = "".concat(usableWindowHeight - this.desktopNavWrapperTop - this.header.getBoundingClientRect().top, "px");
        } else {
          this.desktopAccountWrapper.style.height = "".concat(usableWindowHeight - this.desktopNavWrapperTop, "px");
        }
      } else {
        this.desktopAccountWrapper.style.height = 'auto';
      }
    }
  }, {
    key: "toggleAccountNav",
    value: function toggleAccountNav(state) {
      this.desktopAccountWrapper.scrollTop = 0;
      var value = !!state;
      this.mobileAccountWrapper.classList.toggle('active');
      this.desktopAccountWrapper.classList.toggle('active');
      this.accountButton.classList.toggle('active');
      if (value) {
        this.setDesktopAccountNavCoords();
        this.setDesktopNavHeight();
      }
      if (this.overlayService) {
        this.overlayService.toggleOverlay(state);
      }
    }
  }, {
    key: "closeActivePrimaryMenu",
    value: function closeActivePrimaryMenu() {
      if (this.primaryMenu) {
        var allActive = this.primaryMenu.querySelectorAll('.active');
        allActive.forEach(function (activeEl) {
          activeEl.classList.remove('active');
        });
      }
    }
  }, {
    key: "onAccountButtonClicked",
    value: function onAccountButtonClicked() {
      this.closeActivePrimaryMenu();
      if (this.accountButton.classList.contains('active')) {
        this.toggleAccountNav(false);
      } else {
        this.toggleAccountNav(true);
      }
    }
  }, {
    key: "setAccountButtonClickEvents",
    value: function setAccountButtonClickEvents() {
      var _this = this;
      this.accountButton.addEventListener('click', function () {
        _this.setDesktopNavWrapperTop();
        _this.onAccountButtonClicked();
      });
    }
  }, {
    key: "toggleState",
    value: function toggleState() {
      this.desktopAccountWrapper.scrollTop = 0;
      this.mobileAccountWrapper.classList.toggle('logged-out');
      this.mobileAccountWrapper.classList.toggle('logged-in');
      this.desktopAccountWrapper.classList.toggle('logged-out');
      this.desktopAccountWrapper.classList.toggle('logged-in');
      this.loggedInText.classList.toggle('show');
      this.loggedOutText.classList.toggle('show');
      this.loggedOutFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.toggle('hidden');
      });
      this.loggedInFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.toggle('hidden');
      });
      this.setDesktopNavHeight();
    }
  }, {
    key: "showLoggedOutStateOnFirstLoad",
    value: function showLoggedOutStateOnFirstLoad() {
      this.mobileAccountWrapper.classList.add('logged-out');
      this.desktopAccountWrapper.classList.add('logged-out');
      this.loggedOutText.classList.add('show');
      this.loggedOutFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.remove('hidden');
      });
      this.loggedInFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.add('hidden');
      });
      this.setDesktopNavHeight();
    }
  }, {
    key: "showLoggedInStateOnFirstLoad",
    value: function showLoggedInStateOnFirstLoad() {
      var _this2 = this;
      this.mobileAccountWrapper.classList.add('logged-in');
      this.desktopAccountWrapper.classList.add('logged-in');
      this.loggedInText.classList.add('show');
      this.loggedOutFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.add('hidden');
      });
      this.loggedInFooterBlocks.forEach(function (footerBlock) {
        footerBlock.classList.remove('hidden');
      });
      this.greetingTextList.forEach(function (greeting) {
        greeting.innerHTML = greeting.innerHTML.concat(" ".concat(_this2.myChartUser.firstName));
      });
      this.setLoggedInMessageCount();
      this.setDesktopNavHeight();
    }
  }, {
    key: "setLoggedInMessageCount",
    value: function () {
      var _setLoggedInMessageCount = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.messageCount) {
                _context.next = 4;
                break;
              }
              this.setMessageCountText();
              _context.next = 8;
              break;
            case 4:
              _context.next = 6;
              return this.fetchAllMessages();
            case 6:
              this.messageCount = _context.sent;
              this.setMessageCountText();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setLoggedInMessageCount() {
        return _setLoggedInMessageCount.apply(this, arguments);
      }
      return setLoggedInMessageCount;
    }()
  }, {
    key: "fetchAllMessages",
    value: function () {
      var _fetchAllMessages = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(lastMessageId) {
        var convoCount, luminisServiceUtils, response, conversations, count;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              convoCount = 0;
              _context2.prev = 1;
              luminisServiceUtils = new LuminisServiceUtils();
              _context2.next = 5;
              return luminisServiceUtils.getPatientConversations(lastMessageId);
            case 5:
              response = _context2.sent;
              conversations = response.conversations;
              conversations.forEach(function (conversation) {
                if (conversation.hasUnreadMessages) {
                  conversation.messages.forEach(function (message) {
                    if (!message.read) {
                      convoCount += 1;
                    }
                  });
                }
              });
              lastMessageId = null;
              if (response.hasMore) {
                lastMessageId = response.lastMessageId;
              }
              if (!lastMessageId) {
                _context2.next = 15;
                break;
              }
              _context2.next = 13;
              return this.fetchAllMessages(lastMessageId);
            case 13:
              count = _context2.sent;
              convoCount += count;
            case 15:
              return _context2.abrupt("return", convoCount);
            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](1);
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 18]]);
      }));
      function fetchAllMessages(_x) {
        return _fetchAllMessages.apply(this, arguments);
      }
      return fetchAllMessages;
    }()
  }, {
    key: "setMessageCountText",
    value: function setMessageCountText() {
      var _this3 = this;
      if (this.messageCount) {
        this.messagesMenu.forEach(function (menu) {
          menu.innerHTML = "".concat(menu.innerHTML, " (").concat(_this3.messageCount, ")");
        });
      }
    }
  }, {
    key: "setAccountMenuClickEvents",
    value: function setAccountMenuClickEvents() {
      var _this4 = this;
      this.closeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this4.setDesktopNavWrapperTop();
          _this4.toggleAccountNav(false);
        });
      });
      this.logOutButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this4.setDesktopNavWrapperTop();
          MyChartUser.logout();
          Account.clearSessionStorage();
          _this4.toggleState();
        });
      });
      this.logInButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this4.setDesktopNavWrapperTop();
        });
      });
    }
  }, {
    key: "setAccountClickEvents",
    value: function setAccountClickEvents() {
      this.setAccountButtonClickEvents();
      this.setAccountMenuClickEvents();
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this5 = this;
      window.addEventListener('scroll', function () {
        _this5.setDesktopNavWrapperTop();
        _this5.setDesktopNavHeight();
      });
      window.addEventListener('load', function () {
        _this5.overlayService = new OverlayService();
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return MyChartUser.getLoggedInUser();
            case 2:
              this.myChartUser = _context3.sent;
              if (this.accountWrapperId) {
                if (this.myChartUser) {
                  this.showLoggedInStateOnFirstLoad();
                } else {
                  Account.clearSessionStorage();
                  this.showLoggedOutStateOnFirstLoad();
                }
                this.setAccountClickEvents();
                this.setListeners();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }], [{
    key: "clearSessionStorage",
    value: function clearSessionStorage() {
      sessionStorage.removeItem('mychartMessageCount');
    }
  }]);
}();
export { Account as default };
(function () {
  window.addEventListener('load', _asyncToGenerator(_regeneratorRuntime().mark(function _callee4() {
    var account;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          account = new Account();
          _context4.next = 3;
          return account.init();
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })));
})(Drupal);